import useSWR from 'swr';

const fetcher = (url) => fetch(url).then(res => res.json());

export default function useEarthSatellites() {
  const { data, error } = useSWR('/data/rtree_satellites.json', fetcher, {
    revalidateOnFocus: false, // Don't refetch when tab regains focus
    refreshInterval: 0,       // Don't poll
  });

  return {
    active: data?.active ?? 0,
    inactive: data?.inactive ?? 0,
    activeCategoryCounts: data?.active_category_counts ?? {},
    inactiveCategoryCounts: data?.inactive_category_counts ?? {}, 
    isLoading: !data && !error,
    isError: !!error,
  };
}
